import Laravel from '../services/Laravel'
import ShopModel from '@/models/ShopModel'

export default {
  async index(shopId) {
    try {
      ShopModel.find(shopId).fetchOrders()
    } catch (error) {
      return Promise.reject(error)
    }
  }, // index
  async update(shopId, orderId, newValues) {
    try {
      const { data: updatedOrder } = await Laravel.post(
        `/shops/${shopId}/orders/${orderId}`,
        newValues
      )
      return updatedOrder
    } catch (error) {
      return Promise.reject(error)
    }
  }, // index
}
